import { useOfferCardContext } from '../context';

export const useTracking = () => {
  const { tracking } = useOfferCardContext();

  return tracking;
};
